export const carousel = () => {

    // const carousels = document.querySelectorAll(".js-carousel");
  const carousels = ".js-carousel";

    const init = () => {
        
        // carousels.forEach((carousel) => {
        //       carousel.onclick = function (e) {
        //         e.preventDefault();
        //         e.stopPropagation();
        //         goToNextImage();
        //       };
        // });

        $(carousels).each(function(){

            $(this).on("click", function(e) {
                e.preventDefault();
                e.stopPropagation();

                var countItems = $(this).children().length;
                var current =  $(this).children('.is-active');
                current.removeClass("is-active");
                if (current.index() === countItems - 1) {
                  $(this).find(".c-carousel__item:first").addClass("is-active");
                } else {
                  current.next().addClass("is-active");
                }

                // goToNextImage();
            });  

          });
                

    };

    const goToNextImage = () => {
        console.log('Go to next image');
    };


    if (carousels.length > 0) {
      init();
    }

};
